// ═══════════════════════════════════════════════
//   LATE NIGHT CART — minigame
// ═══════════════════════════════════════════════
//
// Objective:   Guide the shopping cart around the store to grab as many konbini snacks as possible.
// Type:        navigation
// Description: Arrow keys / WASD steer the cart on desktop; swipe on mobile.
//              Each snack collected grows the tail by one grid cell. Hitting a
//              wall or your own tail ends the run immediately. No timer — pure
//              skill. Speed ramps every GAME_KONBISNAKE.speedTierEvery items.
// Tunables:    GAME_KONBISNAKE in data.js.

const {S, canvas, ctx, claimGameReward, addCleanup, showGameOver} = window;

// Module-level runtime state — reset in startKonbisnake
let snakeCells   = [];
let snakeDir     = {x: 1, y: 0};
let snakeNextDir = {x: 1, y: 0};
let snakeFood    = null;
let moveInterval = 200;
let lastMove     = 0;
let touchX = 0, touchY = 0;

function startKonbisnake() {
    const CFG  = window.GAME_KONBISNAKE;
    const cs   = CFG.cellSize;
    const cols = Math.floor(canvas.width  / cs);
    const rows = Math.floor(canvas.height / cs);
    const sx   = Math.floor(cols / 2);
    const sy   = Math.floor(rows / 2);

    window.gameRunning = true;
    window.gameScore   = 0;
    document.getElementById('mg-score').textContent = '0';
    document.getElementById('mg-timer').textContent = '∞';

    snakeCells   = [{x: sx, y: sy}, {x: sx - 1, y: sy}, {x: sx - 2, y: sy}];
    snakeDir     = {x: 1, y: 0};
    snakeNextDir = {x: 1, y: 0};
    moveInterval = CFG.moveIntervalStart;
    lastMove     = Date.now();

    spawnSnakeFood(cols, rows);

    window.gameInterval = setInterval(konbisnakeLoop, 16);
    addCleanup(() => clearInterval(window.gameInterval));
    addCleanup(() => { snakeCells = []; snakeFood = null; });

    document.addEventListener('keydown', konbisnakeKey);
    addCleanup(() => document.removeEventListener('keydown', konbisnakeKey));

    canvas.addEventListener('touchstart', konbisnakeTouchStart, {passive: true});
    canvas.addEventListener('touchend',   konbisnakeTouchEnd,   {passive: true});
    addCleanup(() => {
        canvas.removeEventListener('touchstart', konbisnakeTouchStart);
        canvas.removeEventListener('touchend',   konbisnakeTouchEnd);
    });
}

function spawnSnakeFood(cols, rows) {
    const emojis = window.GAME_KONBISNAKE.foodEmojis;
    let fx, fy, tries = 0;
    do {
        fx = Math.floor(Math.random() * cols);
        fy = Math.floor(Math.random() * rows);
        tries++;
    } while (tries < 200 && snakeCells.some(c => c.x === fx && c.y === fy));
    snakeFood = {x: fx, y: fy, emoji: emojis[Math.floor(Math.random() * emojis.length)]};
}

function konbisnakeLoop() {
    if (!window.gameRunning) return;
    const CFG  = window.GAME_KONBISNAKE;
    const cs   = CFG.cellSize;
    const cols = Math.floor(canvas.width  / cs);
    const rows = Math.floor(canvas.height / cs);
    const now  = Date.now();

    if (now - lastMove >= moveInterval) {
        snakeDir = snakeNextDir;
        lastMove = now;

        const head = snakeCells[0];
        const nx = head.x + snakeDir.x;
        const ny = head.y + snakeDir.y;

        if (nx < 0 || nx >= cols || ny < 0 || ny >= rows ||
            snakeCells.some(c => c.x === nx && c.y === ny)) {
            endKonbisnake();
            return;
        }

        snakeCells.unshift({x: nx, y: ny});

        if (snakeFood && nx === snakeFood.x && ny === snakeFood.y) {
            window.gameScore++;
            document.getElementById('mg-score').textContent = window.gameScore;
            SFX.play('hit');
            if (window.gameScore % CFG.speedTierEvery === 0) {
                moveInterval = Math.max(CFG.moveIntervalMin, moveInterval - CFG.speedStep);
            }
            spawnSnakeFood(cols, rows);
        } else {
            snakeCells.pop();
        }
    }

    // ── Render ──────────────────────────────────────────────────────
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#0d0d1a';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Faint store-floor grid
    ctx.strokeStyle = 'rgba(255,255,255,0.04)';
    ctx.lineWidth = 1;
    for (let x = 0; x <= canvas.width; x += cs) {
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, canvas.height); ctx.stroke();
    }
    for (let y = 0; y <= canvas.height; y += cs) {
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(canvas.width, y); ctx.stroke();
    }

    // Snake body
    const len = snakeCells.length;
    snakeCells.forEach((c, i) => {
        const px = c.x * cs, py = c.y * cs;
        if (i === 0) {
            ctx.fillStyle = '#f72585';
            ctx.beginPath();
            ctx.roundRect(px + 1, py + 1, cs - 2, cs - 2, 4);
            ctx.fill();
            ctx.font        = `${cs - 4}px serif`;
            ctx.textAlign   = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText('🛒', px + cs / 2, py + cs / 2 + 1);
        } else {
            const t = i / Math.max(len - 1, 1);
            ctx.fillStyle = `hsl(${310 - t * 40}, 75%, ${52 - t * 12}%)`;
            ctx.beginPath();
            ctx.roundRect(px + 2, py + 2, cs - 4, cs - 4, 3);
            ctx.fill();
        }
    });

    // Food item
    if (snakeFood) {
        ctx.font        = `${cs - 2}px serif`;
        ctx.textAlign   = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(snakeFood.emoji, snakeFood.x * cs + cs / 2, snakeFood.y * cs + cs / 2 + 1);
    }
}

function konbisnakeKey(e) {
    if (!window.gameRunning || S.currentGame !== 'konbisnake') return;
    const map = {
        ArrowUp:    {x:  0, y: -1}, ArrowDown:  {x: 0, y:  1},
        ArrowLeft:  {x: -1, y:  0}, ArrowRight: {x: 1, y:  0},
        w:          {x:  0, y: -1}, s:          {x: 0, y:  1},
        a:          {x: -1, y:  0}, d:          {x: 1, y:  0},
    };
    const nd = map[e.key];
    if (!nd) return;
    // Guard against 180° reversal into the queued direction
    if (nd.x === -snakeNextDir.x && nd.y === -snakeNextDir.y) return;
    e.preventDefault();
    snakeNextDir = nd;
}

function konbisnakeTouchStart(e) {
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
}

function konbisnakeTouchEnd(e) {
    if (!window.gameRunning || S.currentGame !== 'konbisnake') return;
    const dx = e.changedTouches[0].clientX - touchX;
    const dy = e.changedTouches[0].clientY - touchY;
    if (Math.abs(dx) < window.GAME_KONBISNAKE.swipeThreshold &&
        Math.abs(dy) < window.GAME_KONBISNAKE.swipeThreshold) return;
    const nd = Math.abs(dx) > Math.abs(dy)
        ? (dx > 0 ? {x: 1, y: 0} : {x: -1, y: 0})
        : (dy > 0 ? {x: 0, y: 1} : {x: 0, y: -1});
    if (nd.x === -snakeNextDir.x && nd.y === -snakeNextDir.y) return;
    snakeNextDir = nd;
}

function endKonbisnake() {
    const CFG = window.GAME_KONBISNAKE;
    window.gameRunning = false;
    SFX.play(window.gameScore > 0 ? 'win' : 'gameover');
    if (window.gameScore >= CFG.nickThreshold) window.unlockNick('lateshopper');
    const p = Math.min(CFG.rewardMax, window.gameScore * CFG.rewardPer);
    showGameOver(claimGameReward('konbisnake', window.gameScore, p));
}

window.startKonbisnake      = startKonbisnake;
window.konbisnakeLoop       = konbisnakeLoop;
window.endKonbisnake        = endKonbisnake;
window.konbisnakeKey        = konbisnakeKey;
window.konbisnakeTouchStart = konbisnakeTouchStart;
window.konbisnakeTouchEnd   = konbisnakeTouchEnd;
